'use client'

import { useAds } from '@/components/providers/AdsProvider'
import { AD_GLOBAL_STATUS } from '@/defs/ad'
import { cn } from '@/utils/commonUtil'

import styles from './AdLeaderboard.module.scss'

type Props = {
  margin?: 'none'
}

export const AdLeaderboard = ({ margin }: Props) => {
  const { adsDisabled } = useAds()

  if (adsDisabled || !AD_GLOBAL_STATUS.LEADERBOARD) return null

  return (
    <div className={cn(styles.container, { margin, styles })}>
      <div data-scm-slot='leaderboard' />
    </div>
  )
}
